<template>
  <canvas :id="`myChart${type ? '-'+type : ''}${section ? '-'+section : ''}`" :width="size * 2" :height="size"></canvas>
</template>

<script>
// import { Line } from "vue-chartjs";

// eslint-disable-next-line no-unused-vars
// import {
//   Chart,
//   LineController,
//   LineElement,
//   PointElement,
//   LinearScale,
//   Title,
//   CategoryScale
// } from 'chart.js'
// import 'chartjs-adapter-moment'
// Chart.register(
//   LineController,
//   LineElement,
//   PointElement,
//   LinearScale,
//   CategoryScale,
//   Title
// )

export default {
  name: 'componentGraph',
  components: {},
  mixins: [],

  data() {
    return {
      chart: null
    }
  },

  props: {
    data: { type: [Array, Object], required: true },
    title: { type: String, required: false },
    step: { type: Number, required: false },
    labels: { type: Array, required: false },
    size: { type: Number, required: false },
    state: { type: Array, required: true },
    lang: { type: String, required: false },
    type: { type: String, required: false },
    section: { type: String, required: false },
  },

  watch: {
    state: {
      handler: function () {
        try {
          this.updateChart()
        } catch (e) {
          console.error(e)
        }
      },
      deep: true
    },
    // data: {
    //   handler: function () {
    //     if (this.chart) this.chart.destroy()
    //     this.createChart()
    //     // this.chart.update()
    //   }
    // }
  },

  mounted() {
    try {
      this.createChart()
      //   console.log(this.data, !!this.title, !!this.color);
    } catch (e) {
      console.error(e)
    }
  },

  methods: {
    setOpacity: (hex, alpha) =>
      `${hex}${Math.floor(alpha * 255)
        .toString(16)
        .padStart(2, 0)}`,

    getRandomColor() {      
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },

    createChart() {
      let datasetData = Array.isArray(this.data)
        ? this.data
        : Object.values(this.data)

      let datasets = []
      let scales = {}
      // const stylePoint = ["triangle", "circle", "cross", "line"];
      for (let [i, line] of datasetData.entries()) {
        line.color = line.color || 'black'

        if(line.type == 'doughnut'){
          datasets.push({
            type: line.type,
            // label: line.label,
            label: this.labels[0],
            data: line.data,
            fill: false,
            backgroundColor: line.color || line.data.map(d => this.getRandomColor()),
            // hoverOffset: 4
          })
          if(['fans_by_gender', 'fans_gender', 'followerCountsByStaffCountRange', 'followerCountsBySeniority', 'followerCountsByIndustry', 'followerCountsByFunction'].includes(line.name)) {
            datasets.push({
              type: line.type,
              label: this.labels[1],
              data: [],
              fill: false,
              backgroundColor: line.color[1] || line.data.map(d => this.getRandomColor()),
              // hoverOffset: 4
            })
            datasets.push({
              type: line.type,
              label: this.labels[2],
              data: [],
              fill: false,
              backgroundColor: line.color[2] || line.data.map(d => this.getRandomColor()),
              // hoverOffset: 4
            })
          }

        }
        else if(line.type == 'bar' && ['fans_country', 'fans_city', 'fans_locale', 'typePosts_graph', 'typePosts_engagement_graph', 'dayPosts_graph', 'dayPosts_engagement_graph'].includes(line.name)){
          datasets.push({
            type: line.type,
            axis: 'y',
            label: line.label,
            data: line.data,
            fill: false,
            backgroundColor: line.color,
            name: line.name
          })
        }
        else if(line.type == 'bar' && ['fans_gender_age', 'fans_age', 'fans_male_age', 'fans_female_age', 'fans_undifined_age',
        'video_views','video_views_paid','video_views_organic','video_views_autoplayed','video_views_click_to_play','video_views_unique','video_repeat_views','video_complete_views_30s','video_view_time'].includes(line.name)){
          datasets.push({
            type: line.type,
            label: line.label,
            data: line.data,
            fill: false,
            backgroundColor: line.color,
            name: line.name
          })
        }
        else if(line.type == 'bar' && ['fans_adds', 'fans_removes', 'fans_paids_adds', 'page_daily_follows', 'page_daily_unfollows'].includes(line.name)){
          datasets.push({
            type: line.type,
            label: line.label,
            data: line.data,
            fill: false,
            backgroundColor: line.color,
            yAxisID: `y-axis-${this.section}-${i}`,
            name: line.name
          })

          scales[`y-axis-${this.section}-${i}`] = {
            display: true,
            position: 'right',
            beginAtZero: true,
            suggestedMax: Math.max(...line.data) + 1,
            title: {
              display: true,
              text: line.labelY,
              color: line.color,
              padding: {
                top: 30,
                bottom: 10
              }
            },
            grid: {
              borderColor: line.color,
              borderWidth: 3
            },
            ticks: {
              stepSize: this.step,
              color: line.color,
              callback: function (value, index, values) {
                return value
              }
            },
          }

          const minValues = []
          const maxValues = []

          const fansRemoves = datasetData.find(l => l.name === 'fans_removes')
          const pageUnfollows = datasetData.find(l => l.name === 'page_daily_unfollows')
          const fansAdds = datasetData.find(l => l.name === 'fans_adds')
          const pageFollows = datasetData.find(l => l.name === 'page_daily_follows')

          if (fansRemoves && fansRemoves.data) minValues.push(Math.min(...fansRemoves.data) - 2)
          if (pageUnfollows && pageUnfollows.data) minValues.push(Math.min(...pageUnfollows.data) - 2)
          if (fansAdds && fansAdds.data) maxValues.push(Math.max(...fansAdds.data) + 2)
          if (pageFollows && pageFollows.data) maxValues.push(Math.max(...pageFollows.data) + 2)

          scales[`y-axis-${this.section}-${i}`].min = minValues.length > 0 ? Math.min(...minValues) : 0
          scales[`y-axis-${this.section}-${i}`].max = maxValues.length > 0 ? Math.max(...maxValues) : 10          
         
        }
        else {
          datasets.push({
            type: line.type || 'line',
            label: line.label,
            data: line.data,
            borderColor: line.color,
            yAxisID: `y-axis-${this.section}-${i}`,
            fill: false,
            backgroundColor:
              line.type === 'bar' ? this.setOpacity(line.color, 0.3) : line.color,
            // borderDash: [i, i],
            tension: 0.3,
            borderWidth: line.type === 'bar' ? 0 : 3,
            // pointStyle: stylePoint[i],
            pointRadius: 2,
            name: line.name
          })
  
          scales[`y-axis-${this.section}-${i}`] = {
            display: true,
            position: i % 2 === 0 ? 'left' : 'right',
            beginAtZero: true,
            suggestedMax: Math.max(...line.data) + 1,
            // suggestedMin: Math.min(...line.data),
            title: {
              display: true,
              text: line.labelY,
              color: line.color,
              padding: {
                top: 30,
                bottom: 10
              }
            },
            grid: {
              borderColor: line.color,
              borderWidth: 3,
              drawOnChartArea: i === 0 || line.label === 'Abonnés',
              // color: 'rgba(0, 0, 0, 0.1)'
              color: ctx => {
                return line.label === 'Abonnés' ? (ctx.tick.value === 0 ? line.color : '') : 'rgba(0, 0, 0, 0.1)'
              },
              lineWidth: ctx => {
                return line.label === 'Abonnés' ? (ctx.tick.value === 0 ? 1.3 : 1) : 1
              },
            },
            ticks: {
              stepSize: this.step,
              color: line.color,
              callback: function (value, index, values) {
                return value + (line.label.toLowerCase() === 'engagement' ? '%' : '');
              }
            },
          }
          if(['fans_evol', 'page_follows'].includes(line.name)) {
            let min = Math.min(...line.data) > 2 ? Math.min(...line.data) - 2 : 0
            let max = Math.max(...line.data) + 2

            scales[`y-axis-${this.section}-${i}`].min = min == 0 || min <=2 ? 0 : min - (max-min)/10
            scales[`y-axis-${this.section}-${i}`].max = max + (max-min)/10
          }    
  
          scales['x'] = {
            offset: false,
            type: 'time',
            time: {
              unit: 'day',
              displayFormats: {
                day: this.lang === 'en' ? 'MM-DD-YYYY' : 'DD-MM-YYYY'
              },
              tooltipFormat: this.lang === 'en' ? 'MM-DD-YYYY' : 'DD-MM-YYYY'
            }
          }
        }

      }

      console.log(this.labels)
      let data = {
        labels: this.labels
          ? this.labels
          : Array.isArray(this.data)
          ? Array.from({ length: datasetData[0].data.length }, (_, i) => i)
          : Object.keys(this.data),
        datasets
      }

      let options = {
        responsive: !this.size,
        stacked: false,
        interaction: {
          mode: 'index',
          intersect: false
        },
        plugins: {
          tooltip: {
            enabled: true,
            callbacks: {
              label: (context) => {
                if(['fans_city', 'fans_locale', 'typePosts_graph', 'typePosts_engagement_graph', 'dayPosts_graph', 'dayPosts_engagement_graph'].includes(this.data[0].name))
                  return `${context.dataset.label} : ${((context.parsed.x / this.data[0].data.reduce((previous, current) => previous+current))*100).toFixed(2)}% (${context.parsed.x})`
                if(['fans_gender_age', 'fans_male_age', 'fans_female_age', 'fans_undifined_age', 'fans_age', 'fans_gender'].includes(context.dataset.name))
                  return `${context.dataset.label} : ${((context.parsed.y / this.data[context.datasetIndex].data.reduce((previous, current) => previous+current))*100).toFixed(2)}% (${context.parsed.y})`
                if(['fans_removes', 'page_daily_unfollows'].includes(context.dataset.name))
                  return `${context.dataset.label} : ${context.parsed.y}`
                return (!context.dataset.name ? context.label : context.dataset.label) + ': ' + (context.parsed.y >= 0 ? context.parsed.y.toFixed(3).replace(/[.,]000$/, "") : context.parsed.toFixed(3).replace(/[.,]000$/, "")) + ((context.dataset.label.toLowerCase() === 'engagement') ? '%' : '');
              }
            }
          },
          legend: {
            onClick: (e) => e.stopPropagation(),
            labels: {
                filter: function(item, chart) {
                    return !item.hidden;
                }
            }
          },
          title: {
            display: true,
            text: this.title
          }
        },
        scales
      }

      if(this.data && this.data[0] && this.data[0].type == 'bar' && ['fans_country', 'fans_city', 'fans_locale', 'typePosts_graph', 'typePosts_engagement_graph', 'dayPosts_graph', 'dayPosts_engagement_graph'].includes(this.data[0].name))
        options.indexAxis = 'y'

      // eslint-disable-next-line no-undef
      this.chart = new Chart(`myChart${this.type ? '-'+this.type : ''}${this.section ? '-'+this.section : ''}`, {
        type: 'line',
        data,
        options
      })
      this.updateChart()
      console.log(this.chart.data.datasets)
    },

    updateChart() {
      console.log('update')
      let left = true
      if(this.state){
        for (let k = 0; k < this.data.length; k++) {
          let b = this.state.includes(k.toString())
          if(this.chart.data.datasets.find(e => e.yAxisID === `y-axis-${this.section}-${k}`))
            this.chart.data.datasets.find(
              (e) => e.yAxisID === `y-axis-${this.section}-${k}`
            ).hidden = !b
          if(this.chart.options && this.chart.options.scales && this.chart.options.scales[`y-axis-${this.section}-${k}`]) {
            this.chart.options.scales[`y-axis-${this.section}-${k}`].display = b
            if (b) {
              this.chart.options.scales[`y-axis-${this.section}-${k}`].position = left
                ? 'left'
                : 'right'
              left = !left
            }
          }
        }
      }
      this.chart.update()
    }
  }
}
</script>